import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Delivery } from 'src/app/models/delivery.schema';
import { Expert } from 'src/app/models/expert.schema';
import { Service } from 'src/app/services/service.service';
import { UserService } from 'src/app/services/user.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ExpertSalaryService } from 'src/app/services/expert-salary.service';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { getItalianMonthName } from 'src/app/helpers/italian-month.helper';
import { DatePipe } from '@angular/common';
import { ExpertService } from 'src/app/services/expert.service';

@Component({
  selector: 'app-expert-salary-dialog',
  templateUrl: './expert-salary-dialog.component.html',
  styleUrls: ['./expert-salary-dialog.component.scss']
})
export class ExpertSalaryDialogComponent implements OnInit {

  @ViewChild('htmlPdf') htmlPdfRef!: ElementRef;
  groups: any;
  deliveries: Delivery[] = [];
  expert: Expert;
  historyPage: string = "";
  currentDate: Date = new Date();
  user: any;
  disableBtn: boolean = false;
  grandTotal: number = 0;
  bottomTotals = {
    refundPlus: 0,
    prezzo: 0,
    plusMinusPrezzo: 0,
    valetSalary: 0,
    valetPlusMinusSalary: 0,
    payAtDeliveryAmount: 0,
    totale: 0,
    grandTotal: 0,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      deliveries: Delivery[],
      expert: Expert,
      historyPage: any
    },
    private authStatusService: AuthStatusService,
    private userService: UserService,
    private dialogRef: MatDialogRef<ExpertSalaryDialogComponent>,
    public service: Service,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private expertSalaryService: ExpertSalaryService,
    private deliveryService: DeliveryService,
    private commanUsesService: CommanUsesService,
    private expertService: ExpertService,
  ) {
    (pdfMake as any).vfs = pdfFonts.vfs;
    this.historyPage = data.historyPage;
    this.deliveries = data.deliveries;
    this.expert = data.expert;
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
  }

  async ngOnInit() {
    this.expert = await this.expertService.getOne(this.expert.id);
    this.user = await this.userService.getMyInformation();
    this.calculateGrandTotal();
    this.generateGrandTotalValues();
  }

  commanForValues(delivery: Delivery) {

    let totals = {
      refundPlus: 0,
      prezzo: 0,
      plusMinusPrezzo: 0,
      valetSalary: 0,
      valetPlusMinusSalary: 0,
      payAtDeliveryAmount: 0,
      totale: 0,
    }

    if(!delivery?.payable && !delivery?.refundRequest) {
      return totals;
    }

    const plus = Number(delivery?.refundRequest?.plusValue ?? 0);
    const valet = Number(delivery?.additionalValetPlusMinus ?? 0);

    totals.refundPlus = valet + (delivery?.refundRequest?.requestStatus === 'approved' ? plus : 0);
    totals.prezzo = Number(delivery?.price) || 0;
    // totals.plusMinusPrezzo = Number(delivery?.additionalPrice) || 0;
    totals.plusMinusPrezzo = (Number(delivery?.additionalPrice) || 0);
    totals.valetSalary = Number(delivery?.expertSalary) || 0;
    totals.valetPlusMinusSalary = Number(delivery?.valetAdditionalPrice) || 0;
    totals.payAtDeliveryAmount = Number(delivery?.payAtDeliveryAmount) || 0;
    totals.totale = (totals.valetSalary + totals.valetPlusMinusSalary + totals.refundPlus) - totals.payAtDeliveryAmount;
    return totals;

  }

  generateGrandTotalValues(){
    this.bottomTotals = {
      refundPlus: 0,
      prezzo: 0,
      plusMinusPrezzo: 0,
      valetSalary: 0,
      valetPlusMinusSalary: 0,
      payAtDeliveryAmount: 0,
      totale: 0,
      grandTotal: 0,
    }

    this.deliveries.forEach((delivery) => {
      const values = this.commanForValues(delivery);
      this.bottomTotals.refundPlus += values.refundPlus;
      this.bottomTotals.prezzo += values.prezzo;
      this.bottomTotals.plusMinusPrezzo += values.plusMinusPrezzo;
      this.bottomTotals.valetSalary += values.valetSalary;
      this.bottomTotals.valetPlusMinusSalary += values.valetPlusMinusSalary;
      this.bottomTotals.payAtDeliveryAmount += values.payAtDeliveryAmount;
      this.bottomTotals.totale += values.totale;
      this.bottomTotals.grandTotal += values.totale;
    });
  }

  calculateGrandTotal(){
    this.grandTotal = 0; 
    this.deliveries.forEach((delivery) => {
      if(delivery?.payable) {
        let amount: any = parseFloat(delivery?.expertSalary ?? '0') + parseFloat(delivery?.valetAdditionalPrice ?? '0')
        const payAtDeliveryAmount = Number(delivery?.payAtDeliveryAmount ?? 0);
        this.grandTotal += parseFloat(amount) - payAtDeliveryAmount;
      }
    });
    this.grandTotal = parseFloat(this.grandTotal.toFixed(2)); 
  }

  showServiceDetails(serviceId: number){
    if(serviceId){
      const service = this.expert?.expertServices.find((item: any) => {
        return item?.id == serviceId;
      });
      return service;
    }
  }

  async downloadSalary() {
    // this.generatePdf('download');
    await this.generatePdfNew('download');
  }

  async viewSalary() {
    // this.generatePdf('view');
    await this.generatePdfNew('open');
  }

  async sendSalary() {
    // this.generatePdf('send');
    await this.generatePdfNew('blob');
  }

  generatePdf(action: string) {
    const DATA: any = this.htmlPdfRef.nativeElement;
    html2canvas(DATA).then((canvas) => {
      const pdfHeight = 297;
      const fileWidth = 208;
      const fileHeight = (canvas.height * fileWidth) / canvas.width;
      const totalPages = Math.ceil(fileHeight / pdfHeight);
      let PDF = new jsPDF('p', 'mm', 'a4');
      for (let i = 0; i < totalPages; i++) {
        if (i > 0) {
          PDF.addPage();
        }
        let position = -i * pdfHeight;
        PDF.addImage(
          canvas.toDataURL('image/png'),
          'PNG',
          0,
          position,
          fileWidth,
          fileHeight
        );
      }

      switch(action) {
        case 'download':
          PDF.save('expert-salary.pdf');
          break;
        case 'view':
          const pdfUrl = URL.createObjectURL(PDF.output('blob'));
          const newWindow = window.open('', '_blank');
          if (newWindow) {
            newWindow.location.href = pdfUrl;
          }
          break;
        case 'send':
          this.disableBtn = true;
          const pdfBlob = PDF.output('blob');
          const formData = new FormData();
          formData.append('salary', pdfBlob, 'expert-salary.pdf');
          formData.append('deliveries', JSON.stringify(this.deliveries));
          let promise = this.expertSalaryService.sendSalaryEmailToExpert(formData, this.expert?.id);
          promise.then((res: any)=> {
            if(res){
              this.disableBtn = false;
              this.openSnackBar('Email di stipendio valet inviata correttamente');
              this.dialogRef.close({ success: true });
              this.deliveries = [];
            }
          }).catch((err: any)=> {
            this.disableBtn = false;
            this.openSnackBar(`${err.error.message}`);
          })
          break;
        default:
          break;
      }
    });
  }

  async generatePdfNew(mode: 'open' | 'print' | 'download' | 'dataurl' | 'base64' | 'blob' = 'open') {
    try {

      this.disableBtn          = true;
      const documentDefinition = this.expert.isVatCode ? this.generateExpertPDF().docDefinition : this.generateReceiptPDF().docDefinition;
      const amount             = this.expert.isVatCode ? this.generateExpertPDF().grandTotal : this.generateReceiptPDF().grandTotal;
      const pdf                = pdfMake.createPdf(documentDefinition);

      switch (mode) {
        case 'open':
          pdf.open();
          this.disableBtn = false;
          break;
        case 'print':
          pdf.print();
          this.disableBtn = false;
          break;
        case 'download':
          pdf.download('expert-salary.pdf');
          this.disableBtn = false;
          break;
        case 'dataurl':
          pdf.getDataUrl((dataUrl) => {
            console.log('Data URL:', dataUrl);
          });
          this.disableBtn = false;
          break;
        case 'base64':
          pdf.getBase64((data) => {
            console.log('Base64:', data);
          });
          this.disableBtn = false;
          break;
        case 'blob':
          pdf.getBlob(async (pdfBlob: Blob) => {
            const formData = new FormData();
            const deliveryIds = this.deliveries.map(d => d.id);
            formData.append('salary', pdfBlob, 'expert-salary.pdf');
            formData.append('deliveries', JSON.stringify(deliveryIds));
            formData.append('emailBody', this.generateHtmlContent());
            formData.append('amount', String(amount || 0));
            let promise = this.expertSalaryService.sendSalaryEmailToExpert(formData, this.expert?.id);
            promise.then((res: any)=> {
              if(res){
                this.disableBtn = false;
                this.openSnackBar('Email di stipendio valet inviata correttamente');
                this.dialogRef.close({ success: true });
                this.deliveries = [];
              }
            }).catch((err: any)=> {
              let errorMsg = '';
              if(err.error.message === 'VALET_NON_HA_EMAIL_DI_STIPENDI' && err.error.statusCode === '404') {
                errorMsg = 'VALET_NON_HA_EMAIL_DI_STIPENDI';
              } else {
                errorMsg = err.error.message;
              }
              this.commanUsesService.showSnackBar(errorMsg);
              this.disableBtn = false;
            })
          });
          break;
      }

    } catch (error) {
      console.log("ERROR", error);
    }
  }

  generateExpertPDF(): { docDefinition: any, grandTotal: string } {

    let totals = {
      grandTotal: 0
    }

    const payableDeliveries: Delivery[] = this.deliveries.filter(
      (delivery: Delivery) => {
        const isPayable = delivery?.payable === true;
        const hasApprovedRefund = delivery?.refundRequest?.requestStatus?.toLowerCase() === 'approved';
        return isPayable || hasApprovedRefund;
      }
    );

    const bodyRows = payableDeliveries.map((delivery: Delivery) => {
      const serviceDetails                = this.showServiceDetails(Number(delivery?.expertServiceId));
      const service                       = serviceDetails?.service || {};
      const pricingModel                  = service?.serviceType?.toLowerCase();
      const salary                        = Number(delivery?.expertSalary ?? 0);
      const plusMinusSalary               = Number(delivery?.valetAdditionalPrice ?? 0);
      const extraAddionalPlusMinusAmount  = Number(delivery?.additionalValetPlusMinus ?? 0);
      const refundRequestPlusAmount       = delivery?.refundRequest?.requestStatus === 'approved' ? Number(delivery?.refundRequest?.plusValue ?? 0) : 0;
      const salaryAndPlusMinusSalary      = ((salary ?? 0) + (plusMinusSalary ?? 0));
      const isFixedSalary                 = pricingModel === 'fixedpricesalary';
      const isHourlySalary                = pricingModel === 'hourlyratesalary';
      const start                         = delivery?.startTime ? delivery.startTime.slice(0, 5) : '';
      const end                           = delivery?.endTime ? delivery.endTime.slice(0, 5) : '';
      const payAtDeliveryAmount           = Number(delivery?.payAtDeliveryAmount ?? 0);
      // totals.grandTotal                   += (salaryAndPlusMinusSalary - payAtDeliveryAmount);
      const totalSalaryOfValet            = (salary + plusMinusSalary + extraAddionalPlusMinusAmount + refundRequestPlusAmount) - payAtDeliveryAmount;
      totals.grandTotal                   += totalSalaryOfValet;

      return [
        "#" + delivery?.id,
        delivery?.address,
        delivery?.billable ? "YES" : "NO",
        new Date(delivery.deliveryDate).toLocaleDateString('it-IT'),
        this.formatProductInfo(delivery),
        service?.serviceName?.toUpperCase() || "---",
        isFixedSalary
          ? "Servizi a Prezzo Fisso"
          : isHourlySalary
          ? "Servizi a Ora"
          : "---",
        delivery.notes || "---",
        isHourlySalary
          ? `${start}-${end}`
          : delivery?.pickUpTime ?? '',
        Number(plusMinusSalary ?? 0).toFixed(2) + "€",
        Number(salary ?? 0).toFixed(2) + "€",
        Number(salaryAndPlusMinusSalary ?? 0).toFixed(2) + "€",
        Number(salaryAndPlusMinusSalary ?? 0).toFixed(2) + "€",
      ];
    });

    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [20, 30, 20, 30],
      content: [
        {
          columns: [
            [
              { text: 'Stipendi', style: 'topTitle' },
              { text: `From: ${this.user?.name} ${this.user?.surname}`, margin: [0, 10, 0, 0], style: 'topText'  },
              { text: `${this.user?.email}`, style: 'topText' },
              { text: 'Website: Deluxy', style: 'topText', link: 'https://deluxy.it', color: '#0000EE' },
            ],
            [
              {
                alignment: 'right',
                stack: [
                  { text: `Date: ${new Date().toLocaleString('it-IT')}`, style: 'topText' },
                  { text: `To: ${this.expert?.user?.surname} ${this.expert?.user?.name}`, bold: true, margin: [0, 10, 0, 0], style: 'topText' },
                  { text: `${this.expert?.address || ''}`, style: 'topText' },
                  { text: `${this.expert?.phone || ''}`, style: 'topText' },
                  { text: `${this.expert?.user?.email || ''}`, style: 'topText' },
                ],
              },
            ],
          ],
          columnGap: 30,
          margin: [0, 0, 0, 20],
        },
  
        {
          table: {
            headerRows: 1,
            widths: [
              'auto', // ID
              'auto', // INFO
              'auto', // DA FATTURARE
              'auto', // DATA
              'auto', // PRODOTTO
              'auto', // NOME SERVIZIO
              'auto', // TIPO SERVIZIO
              'auto', // NOTE
              'auto', // ORE
              'auto', // +/- SALARY
              'auto', // +/- SALARY
              'auto', // +/- SALARY AND SALARY
              'auto'  // TOTALE
            ],  
            body: [
              [
                { text: 'ID', style: 'tableHeader' },
                { text: 'INFO', style: 'tableHeader' },
                { text: 'DA FATTURARE', style: 'tableHeader' },
                { text: 'DATA', style: 'tableHeader' },
                { text: 'PRODOTTO', style: 'tableHeader' },
                { text: 'NOME SERVIZIO', style: 'tableHeader' },
                { text: 'TIPO SERVIZIO', style: 'tableHeader' },
                { text: 'NOTE', style: 'tableHeader' },
                { text: 'ORE', style: 'tableHeader' },
                { text: '+/- ', style: 'tableHeader' },
                { text: 'SALARY', style: 'tableHeader' },
                { text: '+/- SALARY', style: 'tableHeader' },
                { text: 'TOTALE', style: 'tableHeader' },
              ],
              ...bodyRows,
              [
                { text: 'TOTALI', colSpan: 12, alignment: 'right', bold: true }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
                { text: totals.grandTotal.toFixed(2) + '€', bold: true },
              ]
            ],
          },
          layout: {
            fillColor: (rowIndex: number) =>
              rowIndex === 0 ? '#c2b55f' : rowIndex % 2 === 0 ? '#f7f7f7' : null,
            hLineColor: () => '#ccc',
            vLineColor: () => '#ccc',
            paddingLeft: () => 3,
            paddingRight: () => 3,
            paddingTop: () => 3,
            paddingBottom: () => 3,
          },
        }
      ],
  
      styles: {
        tableHeader: {
          bold: true,
          fontSize: 8,
          color: 'white',
          alignment: 'center',
        },
        topTitle: {
          color: '#c2b55f',
          fontSize: 18,
          bold: true,
          marginBottom: 10,
        },
        topText: {
          fontSize: 9,
        }
      },
  
      defaultStyle: {
        fontSize: 7,
      },
    };
    return {
      docDefinition: docDefinition,
      grandTotal: totals.grandTotal.toFixed(2)
    };
  }

  generateReceiptPDF(): { docDefinition: any, grandTotal: string } {
    const holdingPercentage = (this.expert.holdingPercentage ?? 100) / 100;
    const fixedAmount = 0.2;
    let netGross = 0;
    let withHoldingTax = 0;
    let newAmount = 0;
    let refunds = 0;
    let totalTransfer = 0;
    let totalRimborsi = 0;
    let totaleBonifico = 0;

    const fullName = this.expert?.user?.surname && this.expert?.user?.name
      ? `${this.expert.user.surname} ${this.expert.user.name}`
      : '---';
    const fiscalCode = this.expert?.fiscalCode || '---';
    const address = this.expert?.address || '---';
    const birthPlace = this.expert?.birthPlace ?? '---';
    const birthDate = this.expert?.dateOfBirth
      ? new DatePipe('it-IT').transform(this.expert?.dateOfBirth, 'dd-MM-yyyy')
      : '---';

    const payableDeliveries: Delivery[] = this.deliveries.filter(
      (delivery: Delivery) => {
        const isPayable = delivery?.payable === true;
        const hasApprovedRefund = delivery?.refundRequest?.requestStatus?.toLowerCase() === 'approved';
        return isPayable || hasApprovedRefund;
      }
    );

    payableDeliveries.forEach(delivery => {

      /*
      const plus = Number(delivery?.refundRequest?.plusValue ?? 0);
      const valet = Number(delivery?.additionalValetPlusMinus ?? 0);
      const refundPlusAddiotionalPlusMinus = valet + (delivery?.refundRequest?.requestStatus === 'approved' ? plus : 0);

      const salary = Number(delivery?.expertSalary ?? 0);
      const additional = Number(delivery?.valetAdditionalPrice ?? 0) + Number(refundPlusAddiotionalPlusMinus);
      const payAtDeliveryAmount = Number(delivery?.payAtDeliveryAmount ?? 0);
      const gross = salary * holdingPercentage;
      const tax = gross * fixedAmount;
      const net = gross - tax;
      const refund = salary * (1 - holdingPercentage) + additional;
      const rimborsi = refund + tax;
      const bonifico = gross - tax + rimborsi;

      netGross += gross;
      withHoldingTax += tax;
      newAmount += net;
      refunds += refund;
      totalTransfer += (net + refund);
      totalRimborsi += rimborsi;
      totaleBonifico += bonifico - payAtDeliveryAmount;
      */

      const oneMinusHoldingPercentage     = (1 - holdingPercentage);
      const fixedAmount_125               = 1.25;
      const fixedAmount_025               = 0.25;
      const salaryAmount                  = Number(delivery?.expertSalary ?? 0);
      const refundRequestPlusAmount       = delivery?.refundRequest?.requestStatus === 'approved' ? Number(delivery?.refundRequest?.plusValue ?? 0) : 0;
      const plusMinusAmount               = Number(delivery?.valetAdditionalPrice ?? 0);
      const extraAddionalPlusMinusAmount  = Number(delivery?.additionalValetPlusMinus ?? 0);
      const paymentOnDeliveryTime         = Number(delivery?.payAtDeliveryAmount ?? 0);
      const totalSalaryAmount             = (salaryAmount + refundRequestPlusAmount + plusMinusAmount + extraAddionalPlusMinusAmount) - paymentOnDeliveryTime;

      const Corrispettivo     = totalSalaryAmount * holdingPercentage * fixedAmount_125;
      const Ritenuta_dacconto = totalSalaryAmount * holdingPercentage * fixedAmount_025;
      const ImportoNetto      = totalSalaryAmount * holdingPercentage;
      const Rimborsi          = totalSalaryAmount * oneMinusHoldingPercentage;
      const TotaleBonifico    = totalSalaryAmount;

      netGross        += Corrispettivo;
      totalRimborsi   += Rimborsi;
      withHoldingTax  += Ritenuta_dacconto;
      newAmount       += ImportoNetto;
      totaleBonifico  += TotaleBonifico;
      
    });

    const today = new Date().toLocaleDateString('it-IT');

    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 60, 40, 60],
      content: [
        {
          text: '(Marca bollo di 2,00 euro se prestazione superiore a euro 77,46)',
          alignment: 'right',
          italics: true,
          fontSize: 9,
          margin: [0, 0, 0, 10]
        },
        {
          columns: [
            {
              stack: [fullName, fiscalCode, address, `${birthPlace}  ${birthDate}`],
              width: '*'
            },
            {
              stack: [
                { text: 'Spett.le Deluxy', bold: true, alignment: 'right' },
                { text: 'Via Varesina 60', alignment: 'right' },
                { text: '20156 Milano (MI)', alignment: 'right' },
                { text: 'P.IVA: 11453140961', alignment: 'right' }
              ],
              width: '*'
            }
          ],
          margin: [0, 0, 0, 20]
        },
        {
          columns: [
            { text: `Nota n° ${payableDeliveries.length} del`, alignment: 'left' },
            { text: today, alignment: 'right' }
          ],
          margin: [0, 0, 0, 20]
        },
        {
          text: `Il sottoscritto ${fullName} dichiara di ricevere la somma lorda di euro € ${netGross.toFixed(2)} (${netGross.toFixed(2)}).`,
          alignment: 'center',
          margin: [0, 0, 0, 10]
        },
        {
          text: `Di cui euro € ${totalRimborsi.toFixed(2)} a titolo di rimborso spese per l’attività occasionale di collaborazione.`,
          alignment: 'center',
          margin: [0, 0, 0, 10]
        },
        {
          text: `Per prestazioni per Deluxy per un totale di 6 giorni.\n\nAl suddetto importo lordo andrà detratta la ritenuta d'acconto (20%) pari a € ${withHoldingTax.toFixed(2)} (${withHoldingTax.toFixed(2)}), per un corrispettivo netto pagato pari a € ${totaleBonifico.toFixed(2)} (${totaleBonifico.toFixed(2)}).`,
          alignment: 'center',
          margin: [0, 0, 0, 20]
        },
        {
          table: {
            widths: ['*', '*'],
            body: [
              [{ text: 'Corrispettivo lordo', bold: true }, `€ ${netGross.toFixed(2)}`],
              [{ text: 'Ritenuta d’acconto', bold: true }, `€ ${withHoldingTax.toFixed(2)}`],
              [{ text: 'Importo Netto', bold: true }, `€ ${newAmount.toFixed(2)}`],
              [{ text: 'Rimborsi', bold: true }, `€ ${totalRimborsi.toFixed(2)}`],
              [
                { text: 'Totale Bonifico', bold: true, color: 'red' },
                { text: `€ ${totaleBonifico.toFixed(2)}`, color: 'red' }
              ]
            ]
          },
          layout: 'lightHorizontalLines',
          margin: [0, 0, 0, 20]
        },
        { text: 'DICHIARA INOLTRE', bold: true, alignment: 'center', margin: [0, 10, 0, 10] },
        {
          ul: [
            'sotto la propria responsabilità:',
            'che la prestazione resa alla ditta ha carattere del tutto occasionale, non svolgendo il sottoscritto prestazione di lavoro autonomo con carattere di abitualità;',
            'di non avere fruito nell’anno ai fini contributivi, della franchigia di € 5.000 prevista dall’art. 44 del D.L. 30 settembre 2003, n. 269;',
            'di non essere soggetto al regime Iva a norma dell’ex art. 5, comma 2, D.P.R. 633/72.'
          ],
          margin: [0, 0, 0, 20]
        },
        {
          columns: [
            { text: 'Data', alignment: 'left' },
            { text: 'In fede', alignment: 'right' }
          ]
        },
        {
          columns: [
            { text: today, alignment: 'left' },
            { text: fullName, alignment: 'right' }
          ]
        }
      ],
      defaultStyle: {
        fontSize: 10
      }
    };

    return {
      docDefinition: docDefinition,
      grandTotal: totalTransfer.toFixed(2)
    };
  }

  formatProductInfo = (delivery: any) => {
    if (delivery?.deliveryProducts && delivery.deliveryProducts.length > 0) {
      return delivery.deliveryProducts
        .map((dProduct: any, index: number, array: any[]) => {
          const productInfo = `${dProduct?.product ? dProduct?.product?.name : ''} - ${dProduct?.productVariant ? dProduct?.productVariant?.variantName : ""}`;
          return index !== array.length - 1 ? productInfo + ', ' : productInfo;
        })
        .join('');
    }
    return '';
  };

  generateHtmlContent() {
    const currentMonthIndex = new Date().getMonth();
    const monthItalian = getItalianMonthName(currentMonthIndex);
    let grandTotal: number = 0;
    const payableDeliveries = this.deliveries.filter(delivery => delivery?.billable);

    payableDeliveries.forEach((delivery: Delivery) => {
      const salary = Number(delivery?.expertSalary ?? 0);
      const plusMinusSalary = Number(delivery?.valetAdditionalPrice ?? 0);
      const salaryAndPlusMinusSalary = ((salary ?? 0) + (plusMinusSalary ?? 0));
      grandTotal += salaryAndPlusMinusSalary;
    });

    let html = `
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
        <h2 style="text-align: center; color: #000;">Dettaglio Stipendi – ${monthItalian}</h2>
        <p>Buongiorno,</p>
        <p>Nella speranza che questa mail vi trovi bene, abbiamo il piacere di inviarvi in allegato il dettaglio corretto delle stipendi <strong>${monthItalian}</strong> con le relative fatture.</p>
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0;">
          <tbody>
    `;

    /*
    html += `
      <tr>
        <td style="padding: 6px 0; color: green;"><strong>Stipendio totale:</strong></td>
        <td style="text-align: right; color: green;">€ ${grandTotal.toFixed(2)}</td>
      </tr>
    `;
    */

    html += `
          </tbody>
        </table>
        <p>Rimaniamo a completa disposizione.</p>
        <p>Cordialmente,<br><br><strong>Amministrazione Deluxy</strong></p>
      </div>
    `;

    return html;
  }

  openSnackBar(message: string) {
    this._snackBar.open(`${message}`, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    })
  }

  async exportSalaryInfo(){
    let res = await this.deliveryService.exportSalaryInfo(this.deliveries);
    let anchor = document.createElement('a');
    anchor.download = 'pro_forma_valet.xlsx';
    anchor.href = (window.webkitURL || window.URL).createObjectURL(res.body);
    anchor.dataset.downloadurl = [res.body.type, anchor.download, anchor.href].join(':');
    anchor.click();
  }

}
